import { FC } from 'react';
import { usePlaceData } from './place.hook';

/**
 * Place component
 * @description Exclusively for the AutomatedOrdersConfirmation as its Place flow.
 * @link https://www.figma.com/file/pCwb00CHfXi1s4Yd5q3q0U/Trader--%7C-File-for-development?type=design&node-id=1787-138486&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const Place: FC = () => {
  const { stages, currentStage } = usePlaceData();

  return stages && currentStage ? stages[currentStage] : null;
};

export { Place };
